var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row no-gutters" }, [
      _c("div", { staticClass: "col-lg-4 col-md-4 col-xs-12 mt-2" }, [
        _c("div", { staticClass: "info" }, [
          _c("div", { staticClass: "info_icon color-primary-500" }, [
            _c("i", {
              staticClass: "fa fa-info",
              attrs: { "aria-hidden": "true" },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pre_show" }, [
            _c("div", { staticClass: "link_pre" }, [
              _vm._v("URL для користувачiв:"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "link" }, [
              _c(
                "a",
                {
                  attrs: {
                    href: "https://office.imcagro.com.ua/file-exchange",
                    target: "_blank",
                  },
                },
                [
                  _vm._v(
                    "\n\t\t\t\t\t\thttps://office.imcagro.com.ua/file-exchange                            "
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-4 col-md-4 col-xs-12 mt-2" }, [
        _c("div", { staticClass: "info" }, [
          _c("div", { staticClass: "info_icon color-primary-500" }, [
            _c("i", {
              staticClass: "fa fa-info",
              attrs: { "aria-hidden": "true" },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pre_show" }, [
            _c("div", { staticClass: "link_pre" }, [_vm._v("Вiльно:")]),
            _vm._v(" "),
            _c("div", { staticClass: "link" }, [
              _vm._v("\n\t\t\t\t\t369 GB                        "),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-4 col-md-4 col-xs-12 mt-2" }, [
        _c("div", { staticClass: "info" }, [
          _c("div", { staticClass: "info_icon color-primary-500" }, [
            _c("i", {
              staticClass: "fa fa-info",
              attrs: { "aria-hidden": "true" },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pre_show" }, [
            _c("div", { staticClass: "link_pre" }, [
              _vm._v("Максимальний розмiр файлу:"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "link" }, [
              _vm._v("\n\t\t\t\t\t600 МB\n\t\t\t\t"),
            ]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }